import React from "react"
import {
  Collapse,
  Fade,
  Grow,
  Slide,
  SlideProps,
  useScrollTrigger,
  Zoom,
} from "@mui/material"

type TransitionComponent =
  | typeof Slide
  | typeof Collapse
  | typeof Fade
  | typeof Grow
  | typeof Zoom

interface IScrollTrigger {
  children?: React.ReactElement
  Transition?: TransitionComponent
  transitionProps?: Object
  scrollOption?: Object
}
const DEFAULT_SCROLL_OPTION = {
  disableHysteresis: true,
  threshold: 700,
}

export const ScrollTrigger: React.FC<IScrollTrigger> = ({
  children = null,
  Transition = Slide,
  transitionProps = { direction: "up" } as SlideProps,
  scrollOption = {},
}) => {
  const trigger = useScrollTrigger({
    ...DEFAULT_SCROLL_OPTION,
    ...scrollOption,
  })

  return (
    <Transition {...transitionProps} in={trigger}>
      {children}
    </Transition>
  )
}
